//console.log("1.09");

// --- intersection observer for 'page has scrolled' detection
// *requires #top-of-site-pixel-anchor element, added in header.php

if (
	"IntersectionObserver" in window &&
	"IntersectionObserverEntry" in window &&
	"intersectionRatio" in window.IntersectionObserverEntry.prototype
) {
	let observer = new IntersectionObserver((entries) => {
		if (entries[0].boundingClientRect.y < 0) {
			document.body.classList.add("body_scrolled");
		} else {
			document.body.classList.remove("body_scrolled");
		}
	});
	observer.observe(document.querySelector("#top-of-site-pixel-anchor"));
}


// --- intersection observer for elements with 'io_observe' class
let observerGenOptions = {
    rootMargin: '0px',
    threshold: 0.5
}

var observerGen = new IntersectionObserver(observerGenCallback, observerGenOptions);

function observerGenCallback(entries, observer) {
    entries.forEach(entry => {
        if(entry.isIntersecting) {
          //do something
			entry.target.classList.add("io_in_view");
        } else {
			entry.target.classList.remove("io_in_view");
		}
    });
};

let observerGenTarget = '.io_observe';
document.querySelectorAll(observerGenTarget).forEach((i) => {
    if (i) {
        observerGen.observe(i);
    }
});

document.addEventListener('DOMContentLoaded', function() {
	
	// Get the carousel element
    var inspoCarousel 	= document.querySelector('#inspirationGallery');

    // Get the buttons
    var playButton = document.querySelector('#inspo-carousel-play');
    var pauseButton = document.querySelector('#inspo-carousel-pause');
	
	// Initialize Bootstrap carousel
	var carouselInstance = new understrap.Carousel(inspoCarousel, {
		interval: 8000, // Set interval as desired
		pause: false    // Allow pause on hover, can be set to 'hover'
	});

    // Add event listener to Play button
    playButton.addEventListener('click', function() {
		carouselInstance.cycle(); // Start cycling
		inspoCarousel.classList.remove('paused');
    });

    // Add event listener to Pause button
    pauseButton.addEventListener('click', function() {
		carouselInstance.pause(); // Pause cycling
		inspoCarousel.classList.add('paused');
    });	
});
	
jQuery(document).ready(function($){
	
    console.log('1.08');
	
	// deep-linking for tabs on Free Consultation page (id 17441)
	// /request-info/#help
	// /request-info/#in-home
	// /request-info/#design-studio
	// /request-info/#repair
	
	// dont really need this first one because its initially-selected, form shown
	//var $tabButtonHowHelp 		= $('#stk-block-tab-label-93a2caf-1'); 
	var $tabButtonInHome 		= $('#stk-block-tab-label-93a2caf-2');
	var $tabButtonDesignStudio 	= $('#stk-block-tab-label-93a2caf-3');
	var $tabButtonRepair 		= $('#stk-block-tab-label-93a2caf-4');
	
	var urlHash = window.location.hash;
	if ( urlHash.length>1 ) {
		//console.log('URL hash: ' + urlHash);
		
		if ( urlHash=='#in-home' && $tabButtonInHome.length>0 ) {
			//console.log('hash is in-home and we have an In Home tab button');
			$tabButtonInHome.click();
		}
		if ( urlHash=='#design-studio' && $tabButtonDesignStudio.length>0 ) {
			$tabButtonDesignStudio.click();
		}
		if ( urlHash=='#repair' && $tabButtonRepair.length>0 ) {
			$tabButtonRepair.click();
		}
	}
	
	var windowWidth = window.innerWidth;
	if ( windowWidth<992 ) {
		// we're in mobile 
		
		var mobileMainNav = $('#main-menu');
		
		mobileMainNav.on('click', 'a.dropdown-toggle', function(){
			$(this).parent().toggleClass('menu_open');
		});
	}
	

	
});